import { Menu } from 'antd';
import styled from 'styled-components';

export const StyledMenu = styled(Menu)`
  &.ant-menu {
    font-size: 16px;

    .ant-menu-item:not(.ant-menu-item-selected) {
      font-weight: 400;
      color: ${({ theme }) => theme.color.neutral_8};
    }
  }

  &.ant-menu-light.ant-menu-horizontal {
    & > .ant-menu-item-selected {
      color: ${({ theme }) => theme.color.neutral_10};

      &::after {
        border-bottom-color: ${({ theme }) => theme.color.primary_6};
      }
    }

    & > .ant-menu-item:hover::after {
      border-bottom-color: ${({ theme }) => theme.color.primary_6};
    }
  }
`;
